"use client";

import React from 'react';
import CollectionsPage from "./CollectionsPage";

const Hpmor = () => {
  return <CollectionsPage documentId={'ywQvGBSojSQZTMpLh'} />
};


export default Hpmor;
